<template>
	<div v-if="everythingLoaded && versionsDiffer">
		<v-form ref="form">
			<egranty-section-divider
				icon="attach_money"
				text="Budżet"
			/>


			<v-layout row wrap>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 8px"><strong>Działania</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Środki z
							MSZ</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
							<strong>Paragraf</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text><strong>Środki z innych źródeł</strong></v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text><strong>Wszystkie źródła</strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<div v-for="(costCompared,index) in costsCompared" :key="index">
				<agency-single-cost
					v-if="costCompared.old"
					:cost="costCompared.old"
					:other-cost="costCompared.current"
					:paragraph-name="costCompared.paragraphName"
					:action-name="costCompared.oldActionName"
					:is-old="true"
					:currency="currency"
				/>
				<agency-single-cost
					v-if="costCompared.current"
					:cost="costCompared.current"
					:other-cost="costCompared.old"
					:paragraph-name="costCompared.paragraphName"
					:action-name="costCompared.currentActionName"
					:is-old="false"
					:currency="currency"
				/>
			</div>

			<div v-for="paragraph in paragraphs" :key="paragraph.arrayId">
				<agency-costs-single-paragraph
					:is-old="true"
					:paragraph="paragraph.oldTotal"
					:other-paragraph="paragraph.currentTotal"
				/>
				<agency-costs-single-paragraph
					:is-old="false"
					:paragraph="paragraph.currentTotal"
					:other-paragraph="paragraph.oldTotal"
				/>
			</div>


			<!--			<v-layout row wrap>-->
			<!--				<v-flex d-flex xs4>-->
			<!--					<v-card color="grey lighten-1">-->
			<!--						<v-card-text style="padding-right: 8px"><strong>Suma (łącznie)</strong>-->
			<!--						</v-card-text>-->
			<!--					</v-card>-->
			<!--				</v-flex>-->
			<!--				<v-flex d-flex xs2>-->
			<!--					<v-card color="grey lighten-1">-->
			<!--						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>{{formatMoney(totalMszFundings)}}</strong>-->
			<!--						</v-card-text>-->
			<!--					</v-card>-->
			<!--				</v-flex>-->
			<!--				<v-flex d-flex xs2>-->
			<!--					<v-card color="grey lighten-1">-->
			<!--						<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">-->
			<!--						</v-card-text>-->
			<!--					</v-card>-->
			<!--				</v-flex>-->
			<!--				<v-flex d-flex xs2>-->
			<!--					<v-card color="grey lighten-1">-->
			<!--						<v-card-text><strong>{{formatMoney(totalOwnFundings)}}</strong></v-card-text>-->
			<!--					</v-card>-->
			<!--				</v-flex>-->
			<!--				<v-flex d-flex xs2>-->
			<!--					<v-card color="grey lighten-1">-->
			<!--						<v-card-text><strong>{{formatMoney(totalFundings)}}</strong></v-card-text>-->
			<!--					</v-card>-->
			<!--				</v-flex>-->
			<!--			</v-layout>-->
		</v-form>
	</div>
</template>

<script>
	import {AgencyContestParagraph} from "@/api/generated/AgencyContestParagraph";
	import {Agency} from "@/api/generated/Agency";
	import {Numbers} from "@/utils/Numbers";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import AgencySingleCost from "./AgencySingleCost";
	import AgencyCostsSingleParagraph from "./AgencyCostsSingleParagraph";

	export default {
		name: "AgencyCompareCostsTable",
		components: {
			AgencyCostsSingleParagraph,
			AgencySingleCost,
			EgrantySectionDivider
		},

		data() {
			return {
				paragraphs: [],
				currency: {
					id: null,
					name: '',
					code: '',
					exchangeRate: ''
				},
				paragraphsLoaded: false,
				dataChanged: false
			};
		},

		watch: {
			current: {
				immediate: true,
				handler(val) {
					if (val === undefined) return;
					this.calculateTotalForParagraph();
				}
			}
		},

		props: {
			agency: {},
			current: {},
			old: {},
			currentActions: {},
			oldActions: {},
			contestId: {}
		},
		mixins: [Numbers],

		computed: {

			costsCompared() {
				if (!this.everythingLoaded) {
					return [];
				}

				let result = [];

				for (let cost of this.old) {
					let serialNumber = this.findActionSerialNumber(this.oldActions, cost.actionId);
					let toAdd = this.emptyCost();
					toAdd.actionSerialNumber = serialNumber;
					toAdd.old = cost;
					toAdd.paragraphId = cost.paragraphId;
					result.push(toAdd);
				}

				for (let cost of this.current) {
					let serialNumber = this.findActionSerialNumber(this.currentActions, cost.actionId);
					let toAdd = result.find(x => x.actionSerialNumber === serialNumber && x.paragraphId === cost.paragraphId);
					if (!toAdd) {
						toAdd = this.emptyCost();
						toAdd.actionSerialNumber = serialNumber;
						toAdd.paragraphId = cost.paragraphId;
						result.push(toAdd);
					}
					toAdd.current = cost;
				}

				for (let compared of result) {
					compared.paragraphName = this.paragraphs.find(x => x.id === compared.paragraphId).name;
					let action = this.currentActions.find(x => x.serialNumber === compared.actionSerialNumber);
					if (action) {
						compared.currentActionName = action.action;
					}
					let oldAction = this.oldActions.find(x => x.serialNumber === compared.actionSerialNumber);
					if (oldAction) {
						compared.oldActionName = oldAction.action;
					}
				}

				return result;
			},

			versionsDiffer() {
				if (this.old === undefined || this.current === undefined) {
					return false;
				}

				let oldCopy = JSON.parse(JSON.stringify(this.old));
				let currentCopy = JSON.parse(JSON.stringify(this.current));

				//id zmieniają się wraz z zapisywaniem projektu, więc nie możemy po nich porównywać
				for (let cost of oldCopy) {
					cost.actionId = 0;
				}

				for (let cost of currentCopy) {
					cost.actionId = 0;
				}

				let comparisonResult = JSON.stringify(oldCopy) === JSON.stringify(currentCopy);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return !comparisonResult;
			},

			everythingLoaded() {
				return this.paragraphs.length
					&& this.current !== undefined
					&& this.currentActions !== undefined;
			},
			//
			// totalOwnFundings() {
			// 	return this.costs.reduce(function (cnt, o) {
			// 		return isNaN(o.ownFundings) ? cnt : cnt + Number(o.ownFundings);
			// 	}, 0);
			// },
			//
			// totalMszFundings() {
			// 	return this.costs.reduce(function (cnt, o) {
			// 		return isNaN(o.mszFundings) ? cnt : cnt + Number(o.mszFundings);
			// 	}, 0);
			// },
			//
			// totalFundings() {
			// 	return this.totalMszFundings + this.totalOwnFundings;
			// }
		},

		methods: {

			findActionSerialNumber(actions, actionId) {
				return actions.find(x => x.id === actionId).serialNumber;
			},

			emptyCost() {
				return {
					actionSerialNumber: null,
					paragraphId: null
				};
			},

			loadParagraphs() {
				AgencyContestParagraph.getAllParagraphs(
					this,
					this.contestId,
					response => {
						this.paragraphs = response;
						this.paragraphs.forEach((paragraph) => {
							this.$set(paragraph, 'arrayId', 'par' + paragraph.id);
							this.$set(paragraph, 'totalMszFundingsForParagraph', 0);
							this.$set(paragraph, 'totalOwnFundingsForParagraph', 0);
						});
						this.calculateTotalForParagraph();
					}
				);
			},

			loadCurrency() {
				Agency.getCurrency(this, this.agency.id, successResponse => {
						this.currency = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować walutę placówki", errorResponse);
					});
			},

			calculateTotalForParagraph() {
				if (!this.everythingLoaded) {
					return;
				}
				this.paragraphs.forEach(
					paragraph => {
						paragraph.currentTotal = this.calculateTotalObject(this.current, paragraph);
						paragraph.oldTotal = this.calculateTotalObject(this.old, paragraph);
					});
			},

			calculateTotalObject(costs, paragraph) {
				let totalObject = {};
				totalObject.name = paragraph.name;
				totalObject.totalMszFundingsForParagraph =
					costs.reduce(function (cnt, o) {
						if (isNaN(o.mszFundings)) {
							return cnt;
						} else {
							return cnt + (o.paragraphId === paragraph.id ? Number(o.mszFundings) : 0);
						}
					}, 0);
				totalObject.totalOwnFundingsForParagraph =
					costs.reduce(function (cnt, o) {
						if (isNaN(o.ownFundings)) {
							return cnt;
						} else {
							return cnt + (o.paragraphId === paragraph.id ? Number(o.ownFundings) : 0);
						}
					}, 0);
				totalObject.totalFundings = totalObject.totalMszFundingsForParagraph + totalObject.totalOwnFundingsForParagraph;
				return totalObject;
			}
		},

		mounted() {
			this.loadParagraphs();
			this.loadCurrency();
		}
	};
</script>

<style scoped>

</style>
